import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ 
  name: 'newLineBr',
  standalone: false 
})
export class NewLineBrPipe implements PipeTransform {
  transform(value: string): string {
    return value ? value.replace(/\n/g, '<br>') : '';
  }
}
